import React, { createContext, useContext, useEffect, useState } from 'react';

import loyalty from '~/account/api/loyalty';
import giftCards from '~/account/api/giftCards';
import { useUser } from '~/context/UserContext';

const RewardsContext = createContext();

const getRewardData = async () => {
    const [rewardTierResponse, loyaltyPointsResponse, giftCardsBalance] =
        await Promise.all([
            loyalty.getRewardTiers(),
            loyalty.getLoyaltyPoints(),
            giftCards.getGiftCardsBalance()
        ]);

    return {
        rewardTiers: rewardTierResponse.data.reward_tiers,
        loyaltyPoints: loyaltyPointsResponse.success
            ? loyaltyPointsResponse.data
            : null,
        giftCardBalance: giftCardsBalance.data?.balance
    };
};

const RewardsContextProvider = ({ children }) => {
    const { isLoggedIn } = useUser();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    // TODO: DISPLAY ERROR MESSAGE!?

    const actions = {
        redeem: async ({ tierId }) => {
            setLoading(true);
            const { success } = await loyalty.redeem(tierId);

            if (success) {
                await fetchAndSetData();
            }

            setLoading(false);
            return success;
        },
        refresh: () => {
            fetchAndSetData();
        }
    };

    const fetchAndSetData = async () => {
        setLoading(true);

        const { rewardTiers, loyaltyPoints, giftCardBalance } =
            await getRewardData();

        setData({
            ...{
                rewardTiers,
                loyaltyPoints,
                giftCardBalance
            }
        });
        setLoading(false);
    };

    useEffect(() => {
        if (isLoggedIn) {
            (async () => {
                await fetchAndSetData();
            })();
        }
    }, [isLoggedIn]);

    return (
        <RewardsContext.Provider
            value={{
                ...data,
                actions,
                loading
            }}
        >
            {children}
        </RewardsContext.Provider>
    );
};

export const useRewards = () => useContext(RewardsContext);

export default RewardsContextProvider;
